export const routes = [
  "/home",
  "/login",
  "/error",
  "/request-status"
];

export const coloredRoutes = ["/home"];